import DOMPurify from 'dompurify';
import { addDiffMarkers, prepareHtml } from './utils';

interface SplitDiffViewProps {
  oldText: string;
  newText: string;
  oldVersionName: string;
  newVersionName: string;
}

const SplitDiffView = ({
  oldText,
  newText,
  oldVersionName,
  newVersionName,
}: SplitDiffViewProps) => {
  const preparedOldText = prepareHtml(oldText);
  const preparedNewText = prepareHtml(newText);

  return (
    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
      <div>
        <h3 className='font-medium mb-2 text-sm flex items-center text-content-primary'>
          <span className='inline-block w-3 h-3 bg-status-error/20 border border-status-error/50 rounded-sm mr-2' />
          {oldVersionName}
        </h3>
        <div
          className='p-4 border rounded bg-surface-subtle border-line-default text-sm text-content-primary split-view-content'
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
              addDiffMarkers(preparedOldText, preparedNewText, true)
            ),
          }}
        />
      </div>

      <div>
        <h3 className='font-medium mb-2 text-sm flex items-center text-content-primary'>
          <span className='inline-block w-3 h-3 bg-status-success/20 border border-status-success/50 rounded-sm mr-2' />
          {newVersionName}
        </h3>
        <div
          className='p-4 border rounded bg-surface-subtle border-line-default text-sm text-content-primary split-view-content'
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
              addDiffMarkers(preparedOldText, preparedNewText, false)
            ),
          }}
        />
      </div>
    </div>
  );
};

export default SplitDiffView;
